function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon_tick"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 30,
  height: 30
}), React.createElement("path", {
  d: "M0,30 L30,30 L30,0 L0,0 L0,30 Z M7.60810811,14.8783784 L11.9864865,19.2567568 L22.2027027,9 L22.7702703,9.56756757 L11.9864865,20.3918919 L7,15.4459459 L7.60810811,14.8783784 Z",
  id: "Shape-Copy-2",
  fill: "#215EFF",
  fillRule: "nonzero"
})));

var SvgIconTick = function SvgIconTick(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_tick.9e8b6525.svg";
export { ForwardRef as ReactComponent };